import { useMemo } from 'react';
import React from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';

interface WebhookEntry {
  datetime: string;
  headers: string;
  endpoint: string;
  body: string;
  hmacValidity: string;
}

interface WebhookTableProps {
  webhookData: { data: WebhookEntry[] }; // Ensure this matches the type you're passing
}

const WebhookTable: React.FC<WebhookTableProps> = ({ webhookData }) => {
  // Memoized columns to prevent re-creation on re-renders
  const columns = useMemo<MRT_ColumnDef<WebhookEntry>[]>(
    () => [
      {
        accessorKey: 'datetime', // This assumes you want to display the datetime field
        header: 'Date/Time',
        size: 100,
      },
      {
        accessorKey: 'headers', // This assumes you want to display the headers field
        header: 'Headers',
        size: 100,
      },
      {
        accessorKey: 'endpoint', // This assumes you want to display the endpoint field
        header: 'Endpoint',
        size: 100,
      },
      {
        accessorKey: 'body', // This assumes you want to display the body field
        header: 'Body',
        size: 300,
      },
      {
        accessorKey: 'hmacValidity',
        header: 'HMAC Validity',
        size: 100,
        Cell: ({ row }) => {
          const value = row.original.hmacValidity;
          if (value === "true") return "Valid";
          if (value === "false") return "Invalid";
          return "Unknown";
        },
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: webhookData.data, // Matches the shape of your updated webhookData
    initialState: { columnVisibility: { headers: false } }, 
  });

  return <MaterialReactTable table={table} />;
};

export default WebhookTable;
